import { useDataSelectionContext } from "../DataSelectionContext";
import DataSelectionModel from "../DataSelectionModal";
import { useMemo } from "react";
import * as yup from "yup";
import { Form } from "react-bootstrap";
import { WfsGetFeatureRequest } from "../../../types/Wfs/WfsGetFeatureRequest";

interface InrixSpeedProfilesFormValues {
  outputFormat: string;
}

export const InrixSpeedProfiles = () => {
  const layerName = "Inrix:SpeedProfiles";
  const { layers, getLayer, wfsOrder } = useDataSelectionContext();
  const layer = useMemo(() => getLayer(layerName), [layers]);

  const initialValues = useMemo(() => ({
    outputFormat: "csv",
  } as InrixSpeedProfilesFormValues), [layer]);

  const schema = useMemo(() =>
    yup.object({
      outputFormat: yup
        .string()
        .oneOf(["csv"])
        .required(),
    })
  , [layer]);

  const onSubmit = (values: InrixSpeedProfilesFormValues) => {
    wfsOrder({
      service: "WFS",
      version: "2.0.0",
      request: "GetFeature",
      resultType: "Results",
      typeNames: layerName,
      outputFormat: values.outputFormat,
      filter: null,
    } as WfsGetFeatureRequest);
  };

  return (
    <>
      <DataSelectionModel
        headerText="Inrix Speed Profiles"
        initialValues={initialValues}
        validationSchema={schema}
        layer={layer}
        onSubmit={onSubmit}>
        {({ values, handleChange, handleBlur }) => (
          <>
            <Form.Group style={{ width: 300 }}>
              <Form.Label htmlFor="outputFormat">Format</Form.Label>
              <Form.Select
                id="outputFormat"
                name="outputFormat"
                value={values.outputFormat}
                onChange={handleChange}
                onBlur={handleBlur}>
                <option value="csv">CSV</option>
              </Form.Select>
            </Form.Group>
          </>
        )}
      </DataSelectionModel>
    </>
  );
};
